import React from "react";

const Menu = () => {
  return (
    <div className="d-flex flex-row justify-content-center bg-dark ">
      <nav className="navbar navbar-light   col-10">
        <a className="navbar-brand text-white" href="/">
          <h1>Movies</h1>
        </a>
      </nav>
    </div>
  );
};

export default Menu;
